module.exports = __webpack_public_path__ + "img/melhor_promo_etiqueta.19eff34.webp";